import * as React from 'react';
import { clone } from 'rambda';
import { CustomJsonVariation, DyMultiVariationTemplates, DyTemplates } from './types';

export function getVariationElements(
  templates: DyTemplates,
  clickHandler: VoidFunction,
  variations: CustomJsonVariation[],
): JSX.Element[] {
  return variations.reduce((acc, variation) => {
    const data = variation.payload.data;
    if (!data) {
      return acc;
    }

    const Template = templates[data.template];
    if (Template) {
      acc.push(<Template key={`${variation.id}`} data={data} onClick={clickHandler} />);
    }

    return acc;
  }, []);
}

export function getMultiVariationElements(
  multiVariationTemplates: DyMultiVariationTemplates,
  clickHandler: VoidFunction,
  variations: CustomJsonVariation[],
): JSX.Element[] {
  const multipleVariationTemplatesMap = variations.reduce((acc, variation) => {
    const data = variation.payload.data;
    if (!data) {
      return acc;
    }

    const config = multiVariationTemplates[data.template];
    if (!config?.Component) {
      return acc;
    }

    const { Component, dataMergeProp } = config;
    if (!acc[data.template]) {
      // we need to clone data here, else we would mutate 'variations' when
      // merging the remaining variations later on
      acc[data.template] = { Component, data: clone(data), key: `${variation.id}` };
    } else {
      const mergeData = data[dataMergeProp];
      if (Array.isArray(mergeData)) {
        acc[data.template].data[dataMergeProp].push(...mergeData);
      }
    }

    return acc;
  }, {});

  return Object.values(multipleVariationTemplatesMap).map(({ Component, data, key }) => {
    return <Component key={key} data={data} onClick={clickHandler} />;
  });
}
